// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__vsR_N","info":"Note_info__2lrHI","note":"Note_note__1-WH8","actions":"Note_actions__3JpJG"};